import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import { quoteShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import { listColumns } from '../quote-columns';

function List({
  data,
  primaryQuoteId,
  showPagination,
  reload,
  onUpdatePrimaryQuote,
  isDisabled,
}) {
  return (
    <ReactTable
      columns={listColumns}
      data={data}
      minRows={2}
      getTdProps={() => ({
        primaryQuoteId,
        onUpdatePrimaryQuote,
        reloadData: reload,
        isDisabled,
      })}
      showPagination={showPagination}
    />
  );
}

List.propTypes = {
  data: arrayOf(quoteShape).isRequired,
  primaryQuoteId: number,
  showPagination: bool.isRequired,
  reload: func.isRequired,
  onUpdatePrimaryQuote: func.isRequired,
  isDisabled: bool,
};

List.defaultProps = {
  primaryQuoteId: undefined,
  isDisabled: false,
};

const QuoteList = withResolved({
  query: api.getQuotes,
  deriveQueryArgs: ({ opportunityId }) => ({ search: { opportunityId } }),
  as: 'data',
})(List);

export default QuoteList;
